import { render, staticRenderFns } from "./LogFormTable.vue?vue&type=template&id=c4a61da4&"
import script from "./LogFormTable.vue?vue&type=script&lang=js&"
export * from "./LogFormTable.vue?vue&type=script&lang=js&"
import style0 from "./LogFormTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports